<template>
  <div id="contact">
    <div class="d-flex justify-content-center">
      <div class="form-container">
        <div class="row justify-content-center">
          <div class="col-12">
            <h2>Contact Us</h2>
            <form>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Name" />
              </div>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Email Address" />
              </div>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Organisation" />
              </div>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Message/Questions" />
              </div>
              <div class="form-group">
                <button class="btn btn-outline-light px-4 py-2" type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
/* CONTACT */
#contact {
	background-image: url("../assets/contact.jpg");
	width: 100%;
	background-attachment: fixed;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
h2{
  color:#fff;
  padding:20px 0;
}
.form-container{
  padding:70px 0;
  width:60%;
}

@media screen and (max-width:500px) {
  .form-container{
    width:80%;
  }
}
</style>